import React from 'react'
import { isLexusCss } from 'utils/utils'


  let urlisLexus = []
  let url = window.location.href;
  isLexusCss(url).then(isLexus => {
      urlisLexus=isLexus
  })

type LabelProps = {
  cssProps?: string
  name: string
  htmlFor?: string
  id?: string 
}

const Label: React.FC<LabelProps> = ({ cssProps, name, htmlFor, id }) => {
  return (
    <label
      id={id} 
      htmlFor={htmlFor}
      className={cssProps ?? `font-${urlisLexus[0]} text-primary `}
    >
      {name}
    </label>
  )
}

export default Label
